import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PdfReportComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/pdf-report.component';
import { AiPdfReportComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/ai-pdf-report.component';
import { CognitiveTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/cognitive-test-card/cognitive-test-card.component';
import { CompetenceTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/competence-test-card/competence-test-card.component';
import { GeneralTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/general-test-card/general-test-card.component';
import { MTCompetenceTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/mt-competence-test-card/mt-competence-test-card.component';
import { OceanTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/ocean-test-card/ocean-test-card.component';
import { ProficiencyTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/proficiency-test-card/proficiency-test-card.component';
import { PronunciationTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/pronunciation-test-card/pronunciation-test-card.component';
import { QuickEnglishTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/quick-english-test-card/quick-english-test-card.component';
import { StepCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/step-card/step-card.component';
import { TechnicalTestCardComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/ai-pdf-report/technical-test-card/technical-test-card.component';
import { DetailPdfReportComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/detail-pdf-report/detail-pdf-report.component';
import { SummaryPdfReportComponent } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/pdf-report/summary-pdf-report/summary-pdf-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicantRoutingModule } from '@app/vinter/components/applicant/applicant-routing.module';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ImageModule } from 'primeng/image';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KnobModule } from 'primeng/knob';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { BackgroundMaskModule } from './background-mask.module';
import { SharedAnswerDetailModule } from './shared-answer-detail-sidebar.module';
import { SharedVinterCodeEditorModule } from './shared-code-editor-vinter.module';
import { SharedCustomChipVinterModule } from './shared-custom-chip.module';
import { SharedDialogModule } from './shared-dialog.module';
import { SharedLicensePlanDialogVinterModule } from './shared-license-plan-dialog.module';
import { SharedPdfChartModule } from './shared-pdf-chart.module';
import { SharedQuestionDetailModule } from './shared-question-detail.module';
import { SharedRatingVinterModule } from './shared-rating-vinter.module';
import { SharedStepQuestionResultListModule } from './shared-step-question-result-list.module';
import { SharedVinterScoreCardModule } from './shared-vinter-score-card.module';
import { SharedVinterModule } from './sharedvinter.module';
import { DeviceTypesPipe } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-detail-tab-list/hiring-process-tab/behavioral-analysis-section/behavioral-analysis-section.component';
import { SuggestApplicantComponentV2 } from '@app/vinter/components/applicant/applicant-detail-v2/applicant-header/suggest-applicant/suggest-applicant.component';

@NgModule({
  declarations: [
    PdfReportComponent,
    DetailPdfReportComponent,
    SummaryPdfReportComponent,
    AiPdfReportComponent,
    StepCardComponent,
    TechnicalTestCardComponent,
    CognitiveTestCardComponent,
    ProficiencyTestCardComponent,
    GeneralTestCardComponent,
    PronunciationTestCardComponent,
    CompetenceTestCardComponent,
    MTCompetenceTestCardComponent,
    OceanTestCardComponent,
    QuickEnglishTestCardComponent,
    DeviceTypesPipe,
    SuggestApplicantComponentV2,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    CommonModule,
    PdfViewerModule,
    ApplicantRoutingModule,
    RatingModule,
    FormsModule,
    SharedCustomChipVinterModule,
    SharedRatingVinterModule,
    ReactiveFormsModule,
    AccordionModule,
    TagModule,
    AvatarModule,
    DialogModule,
    TabViewModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    OverlayPanelModule,
    InputTextareaModule,
    AccordionModule,
    SharedLicensePlanDialogVinterModule,
    SkeletonModule,
    ConfirmDialogModule,
    ToastModule,
    TranslateModule,
    KnobModule,
    SliderModule,
    TooltipModule,
    InputSwitchModule,
    ProgressBarModule,
    TimelineModule,
    ChipModule,
    CardModule,
    BadgeModule,
    SidebarModule,
    AvatarModule,
    ImageModule,
    RadioButtonModule,
    ChipModule,
    CardModule,
    CheckboxModule,
    SidebarModule,
    RadioButtonModule,
    BadgeModule,
    ImageModule,
    DropdownModule,
    SharedVinterModule,
    SharedVinterCodeEditorModule,
    TableModule,
    DialogModule,
    BackgroundMaskModule,
    SharedDialogModule,
    SharedStepQuestionResultListModule,
    SharedQuestionDetailModule,
    SharedAnswerDetailModule,
    SharedVinterScoreCardModule,
    SharedPdfChartModule,
    ChartModule,
  ],
  exports: [
    PdfReportComponent,
    DetailPdfReportComponent,
    SummaryPdfReportComponent,
    AiPdfReportComponent,
    StepCardComponent,
    TechnicalTestCardComponent,
    CognitiveTestCardComponent,
    ProficiencyTestCardComponent,
    GeneralTestCardComponent,
    PronunciationTestCardComponent,
    CompetenceTestCardComponent,
    MTCompetenceTestCardComponent,
    OceanTestCardComponent,
    QuickEnglishTestCardComponent,
    SuggestApplicantComponentV2,
    ]
})
export class SharedPdfModule { }